<template>
  <TarjetaDatos titulo="Aviso de Renovación" tipo="naranja">
    <Campo2L :valor="avisoRenovacion.numPoliza" etiqueta="Póliza" />
    <Campo2L :valor="avisoRenovacion.riesgo" :etiqueta="tituloRiesgo" />
    <Campo2L
      v-if="isAutos"
      :valor="avisoRenovacion.modeloVehiculo"
      etiqueta="Vehículo"
    />
    <Campo2L
      :valor="avisoRenovacion.fechaVencimiento | dateDDMMYYYY"
      etiqueta="Fecha de Vencimiento:"
    />
    <Campo2L
      :valor="avisoRenovacion.datosBancarios"
      etiqueta="Datos Bancarios"
    />
    <Campo2L :valor="avisoRenovacion.formaPago" etiqueta="Forma de Pago" />
    <div class="etiq-1">Recibos</div>
    <ul class="campo">
      <li v-for="recibo in avisoRenovacion.lstRecibosAR" :key="recibo.idRecibo">
        {{ recibo.fecRecibo | dateDDMMYYYY }}: {{ recibo.importeNeto }} €
      </li>
    </ul>
    <div v-if="avisoRenovacion.documento">
      <a class="ripple" href="#" target="_blank" @click.prevent="downloadDocumento(avisoRenovacion.documento.uuid)">{{ avisoRenovacion.documento.label }}</a>
    </div>
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    avisoRenovacion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tituloRiesgo() {
      switch (this.avisoRenovacion.tipoNegocio) {
        case "V":
          return "Matrícula";
        case "H":
          return "Vivienda";
        case "D":
          return "Tomador";
        default:
          return "Riesgo";
      }
    },
    isAutos() {
      return this.avisoRenovacion.tipoNegocio == "V";
    },
    
  },
  methods:{
    downloadDocumento: async function (uuid) {
      this.$store.dispatch("dowloadDocumento", uuid);
    },
  }
};
</script>

<style scoped>
.etiq-1 {
  font-size: 80%;
  color: #0053a2;
}
.campo {
  padding-bottom: 0.5rem;
}
</style>
